import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

import { Spinner } from '@shared/components/spinner/spinner';

@Component({
  selector: 'app-image-upload',
  imports: [CommonModule, Spinner],
  templateUrl: './image-upload.html',
  styleUrl: './image-upload.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImageUpload {

  @Output() fileSelected = new EventEmitter<File>();
  @Output() imageRemoved = new EventEmitter<void>();
  
  @Input() imageUrl: string | null = null;
  @Input() showPreviewOnSelect: boolean;
  @Input() isShowDropDown : boolean;
  @Input() wrapperClass: string;
  @Input() defaultimage: string;
  @Input() buttonClass: string;
  @Input() buttonText: string;
  @Input() helperText = '';
  @Input() loading = false;
  @Input() immediateRemove = true;
  triggerUpload(fileInput: HTMLInputElement): void {
    fileInput.click();
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (!file) return;
    if (this.showPreviewOnSelect) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imageUrl = reader.result as string;
        this.fileSelected.emit(file);
      };
      reader.readAsDataURL(file);
    } else {
      // emit file without showing preview
      this.fileSelected.emit(file);
    }
  }

  onRemove(): void {
    if (this.immediateRemove && this.showPreviewOnSelect) {
      this.imageUrl = null;
    }
    this.imageRemoved.emit();
  }

}
